import { TYPE_MYTEL_ERROR_CODE, TYPE_MYTEL_MAGICWHEEL, TYPE_MYTEL_REVENUE, TYPE_MYTEL_VM } from "./type";

export const getDataRevenueMytel = (url) => {
  return {
    type: TYPE_MYTEL_REVENUE,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataErrorCodeMytel = (url) => {
  return {
    type: TYPE_MYTEL_ERROR_CODE,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataVmMytel = (url) => {
  return {
    type: TYPE_MYTEL_VM,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataMagicWheel = (url) => {
  return {
    type: TYPE_MYTEL_MAGICWHEEL,
    meta: {
      url,
      method: "GET",
    },
  };
};
